/**
 * 공통 상수 및 유틸리티
 */

export const ADMIN_EMAILS: string[] = ['jonghyuk.jeon@gmail.com', 'drumbrab@gmail.com'];

/**
 * 작성자 이름 포맷팅 (내부 계정명 → 표시 이름 변환)
 */
export function formatAuthorName(name: string | null | undefined): string {
    if (!name) return '이름 없음';
    if (name === 'jonghyuk.jeon') return '전종혁';
    return name;
}
